import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

export interface HgcSessionLimitTemplate {
	activeFrom: string;
	limitValue: number;
	limitPeriod: string;
}

export enum HgcSessionLimitPeriod {
	Daily = 1,
	Weekly = 7,
	Monthly = 30,
}

export enum HgcSessionLimitSuggestionAmounts {
	Daily = 24,
	Weekly = 168,
	Monthly = 720,
}

export enum HgcSessionLimitPeriodTranslationsEnum {
	Daily = "dailySessionLimit",
	Weekly = "weeklySessionLimit",
	Monthly = "monthlySessionLimit",
}

export interface HgcSessionLimitFormGroup extends UntypedFormGroup {
	controls: {
		sessionLimitAmount: UntypedFormControl;
		sessionLimitPeriod: UntypedFormControl;
	};
}
